import { useRef, useState } from 'react';
import jsQR from 'jsqr';
import { ImageUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

// Decode a QR from an uploaded photo/screenshot (camera on tablets) or accept pasted QR text.
async function decodeImage(file) {
  const img = await createImageBitmap(file);
  for (const scale of [1, 0.5, 2]) {
    const c = document.createElement('canvas');
    c.width = Math.round(img.width * scale); c.height = Math.round(img.height * scale);
    const ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, c.width, c.height);
    const hit = jsQR(ctx.getImageData(0, 0, c.width, c.height).data, c.width, c.height);
    if (hit?.data) return hit.data;
  }
  return null;
}

export const QrInput = ({ value, onChange }) => {
  const ref = useRef(null);
  const [msg, setMsg] = useState('');
  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setMsg('Reading QR…');
    try {
      const data = await decodeImage(f);
      if (data) { onChange(data); setMsg('QR read from image'); } else setMsg('No QR found in this image — try a clearer, closer photo');
    } catch { setMsg('Could not open this image'); }
    if (ref.current) ref.current.value = '';
  };
  return (
    <div className="space-y-2">
      <Label className="text-xs">Supplier invoice QR</Label>
      <div className="flex gap-2 items-center">
        <input ref={ref} type="file" accept="image/*" capture="environment" className="hidden" onChange={onFile} data-testid="piv-qr-file" />
        <Button type="button" variant="outline" size="sm" onClick={() => ref.current?.click()} data-testid="piv-qr-upload-btn">
          <ImageUp size={14} className="mr-1" />Photo / image of QR
        </Button>
        {msg && <span className="text-xs text-muted-foreground" data-testid="piv-qr-msg">{msg}</span>}
      </div>
      <Textarea rows={2} value={value} onChange={(e) => onChange(e.target.value)} placeholder="…or paste the QR text (base64)"
        className="font-mono text-xs" data-testid="piv-qr-text" />
    </div>
  );
};
